import * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CloneExpenseRateSheetMutationVariables = Types.Exact<{
  newName: Types.Scalars['String'];
  oldName: Types.Scalars['String'];
}>;


export type CloneExpenseRateSheetMutation = { __typename?: 'MutationModel', expenseRates?: { __typename?: 'ExpenseRatesMutationModel', cloneRateSheet?: { __typename?: 'ValidationResponse', errors?: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string } | null> | null } | null } | null };


export const CloneExpenseRateSheetDocument = gql`
    mutation CloneExpenseRateSheet($newName: String!, $oldName: String!) {
  expenseRates {
    cloneRateSheet(newName: $newName, oldName: $oldName) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type CloneExpenseRateSheetMutationFn = Apollo.MutationFunction<CloneExpenseRateSheetMutation, CloneExpenseRateSheetMutationVariables>;

/**
 * __useCloneExpenseRateSheetMutation__
 *
 * To run a mutation, you first call `useCloneExpenseRateSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneExpenseRateSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneExpenseRateSheetMutation, { data, loading, error }] = useCloneExpenseRateSheetMutation({
 *   variables: {
 *      newName: // value for 'newName'
 *      oldName: // value for 'oldName'
 *   },
 * });
 */
export function useCloneExpenseRateSheetMutation(baseOptions?: Apollo.MutationHookOptions<CloneExpenseRateSheetMutation, CloneExpenseRateSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneExpenseRateSheetMutation, CloneExpenseRateSheetMutationVariables>(CloneExpenseRateSheetDocument, options);
      }
export type CloneExpenseRateSheetMutationHookResult = ReturnType<typeof useCloneExpenseRateSheetMutation>;
export type CloneExpenseRateSheetMutationResult = Apollo.MutationResult<CloneExpenseRateSheetMutation>;
export type CloneExpenseRateSheetMutationOptions = Apollo.BaseMutationOptions<CloneExpenseRateSheetMutation, CloneExpenseRateSheetMutationVariables>;